// extracted by mini-css-extract-plugin
export default {"renderer":"MarkdownRenderer-module__renderer--a4376"};